import { itemViewCellStyles } from "components/common-style/common-style";

export const customerSidebarViewContentStyles = { padding: 0 };
export const assetImageViewStyle = { height: '15.9375em', width: '19.5em' };
export const assetitemViewCellStyles = { ...itemViewCellStyles };
export const assetCellsStyle = { ...itemViewCellStyles, verticalAlign: 'top' };

